@if (tabs().length > 0) {
    <app-tab-outline class="contentVisualsTabs" [tabs]="tabs()" [(selectedTabIndex)]="selectedTabIndex" #tabOutlineComponent>
    </app-tab-outline>
}
<router-outlet></router-outlet>
